// Admin breadcrumbs;
const ADMIN_ORGANISATION_HOME = [
  { title: 'word.organisations', routeTo: { name: 'admin-organisation-list' } },
];

const ADMIN_RESEARCH_HOME = [
  { title: 'word.researches', routeTo: { name: 'admin-research-list' } },
];
const ADMIN_RESEARCH_SET_HOME = [
  { title: 'word.research_sets', routeTo: { name: 'admin-research-set-list' } },
];
const ADMIN_RESEARCH_PROPOSAL_HOME = [
  ...ADMIN_RESEARCH_HOME,
  { title: 'word.research_proposals', routeTo: { name: 'admin-research-proposal-list' } },
];
const ADMIN_ITEM_HOME = [
  { title: 'word.items', routeTo: { name: 'admin-item-list' } },
];
const ADMIN_COUNTRY_HOME = [
  { title: 'word.countries', routeTo: { name: 'admin-country-list' } },
];
const ADMIN_CHAT_THREAD_HOME = [
  { title: 'word.ai', routeTo: { name: 'admin-chat-thread-list' } },
];

// Reviewer breadcrumbs;
// Het reviewerdashboard heet in de sidebar "Mijn coins", dus hier ook.
const REVIEWER_HOME = [
  { title: 'phrase.my_coins', routeTo: { name: 'reviewer-dashboard' } },
];

const REVIEWER_BREADCRUMBS = {
  'reviewer-dashboard': () => [{ title: 'phrase.my_coins' }],
  // Het beginpunt zelf: het huisje is genoeg.
  'public-dashboard': () => [],
  // Deze twee zetten hun eigen crumbs zodra de titel binnen is.
  'public-research-set': () => [...REVIEWER_HOME],
  'reviewer-research-answers': () => [...REVIEWER_HOME],
  'public-organisation-list': () => [{ title: 'word.organisations' }],
  'public-commercial-list': () => [{ title: 'phrase.all_commercials' }],
  'public-article-list': () => [{ title: 'word.articles' }],
  // De detailpagina's zetten hun eigen crumbs zodra de titel binnen is.
  'public-organisation-detail': () => [{ title: 'word.organisations' }],
  'public-article-detail': () => [{ title: 'word.articles' }],
  // Eigen ingang in de sidebar, dus niet onder "Mijn coins".
  'reviewer-product-list': () => [{ title: 'phrase.gift_shop' }],
  // Zoals in de sidebar.
  'reviewer-user-profile': () => [{ title: 'phrase.my_account' }],
};

const ADMIN_BREADCRUMBS = {
  'admin-chat-thread-list': () => ADMIN_CHAT_THREAD_HOME,
  'admin-graph-list': () => [
    ...ADMIN_CHAT_THREAD_HOME,
    { title: 'Graph Visualizer', disableTranslation: true },
  ],
  'admin-ai-cost-overview': () => [
    ...ADMIN_CHAT_THREAD_HOME,
    { title: 'word.costs' },
  ],
  'admin-ai-log-list': () => [
    ...ADMIN_CHAT_THREAD_HOME,
    { title: 'AI Logs', disableTranslation: true },
  ],
  'admin-ai-prompt-list': () => [
    ...ADMIN_CHAT_THREAD_HOME,
    { title: 'phrase.prompts' },
  ],
  'admin-ai-prompt-detail': (options) => [
    ...ADMIN_CHAT_THREAD_HOME,
    { title: 'phrase.prompts', routeTo: { name: 'admin-ai-prompt-list' } },
    { title: options.title || '[prompt]', disableTranslation: true },
  ],
  'admin-ai-log-run-detail': (options) => [
    ...ADMIN_CHAT_THREAD_HOME,
    { title: 'AI Logs', disableTranslation: true, routeTo: { name: 'admin-ai-log-list' } },
    { title: options.graphRunUuid || '[run]', disableTranslation: true },
  ],
  'admin-chat-thread-detail': (options) => [
    ...ADMIN_CHAT_THREAD_HOME,
    { title: options.title || '[no title]', disableTranslation: true },
  ],
  'admin-review-session-list': () => [
    { title: 'word.sessions' },
  ],
  'admin-review-session-detail': (options) => [
    { title: 'word.sessions', routeTo: { name: 'admin-review-session-list' } },
    { title: options.title || '[no title]', disableTranslation: true },
  ],
  'admin-home': () => [],
  'admin-item-list': () => ADMIN_ITEM_HOME,
  'admin-item-detail': (options) => [
    ...ADMIN_ITEM_HOME,
    { title: options.title, disableTranslation: true },
  ],
  'admin-country-list': () => ADMIN_COUNTRY_HOME,
  'admin-country-detail': (options) => [
    ...ADMIN_COUNTRY_HOME,
    { title: options.title || options.countryCode, disableTranslation: true },
  ],
  'admin-newsletter-registration-list': () => [
    { title: 'word.newsletter' },
  ],
  'admin-user-event-list': () => [
    { title: 'word.logins' },
  ],
  'admin-icon-list': () => [
    { title: 'word.styleguide' },
  ],
  'admin-api-docs': () => [
    { title: 'phrase.api_documentation' },
  ],
  'admin-organisation-document-list': () => {
    return [
      {
        title: 'word.documents',
        routeTo: { name: 'admin-organisation-document-list' },
      },
    ]
  },
  'admin-organisation-assistant-detail': (options) => [
    ...ADMIN_ORGANISATION_HOME,
    {
      title: options.organisation?.name,
      disableTranslation: true,
      routeTo: { name: 'admin-organisation-detail', params: { id: options.organisation?.id } },
    },
    { title: 'word.ai_assistant' },
  ],
  'admin-organisation-list': () => ADMIN_ORGANISATION_HOME,
  'admin-organisation-detail': (options) => [
    ...ADMIN_ORGANISATION_HOME,
    { title: options.organisationName, disableTranslation: true },
  ],
  'admin-research-detail': (options) => [
    ...ADMIN_RESEARCH_HOME,
    { title: options.title, disableTranslation: true },
  ],
  'admin-research-builder-v2': (options) => [
    ...ADMIN_RESEARCH_HOME,
    {
      title: options.title || 'word.research_setup',
      disableTranslation: !options.title,
      routeTo: options.uuid ? { name: 'admin-research-detail', params: { uuid: options.uuid } } : undefined,
    },
    { title: 'word.builder' },
  ],
  'admin-research-list': () => ADMIN_RESEARCH_HOME,
  'admin-research-set-list': () => ADMIN_RESEARCH_SET_HOME,
  'admin-research-set-detail': (options) => [
    ...ADMIN_RESEARCH_SET_HOME,
    { title: options.title || '[no title]', disableTranslation: true },
  ],
  'admin-research-proposal-detail': (options) => [
    ...ADMIN_RESEARCH_PROPOSAL_HOME,
    { title: options.title, disableTranslation: true },
  ],
  'admin-research-proposal-list': () => ADMIN_RESEARCH_PROPOSAL_HOME,
};


// Organisation breadcrumbs;
const ORGANISATION_HOME = [];
const ORGANISATION_DOCUMENTS_HOME = [
  { title: 'word.documents', routeTo: { name: 'organisation-document-list' } },
];

const ORGANISATION_BREADCRUMBS = {
  'partner-researches': () => [{ title: 'word.researches' }],
  'organisation-chat-thread-detail': () => [
    ...ORGANISATION_HOME,
    { title: 'word.ai_assistant' },
  ],
  'organisation-document-detail': (options) => [
    ...ORGANISATION_DOCUMENTS_HOME,
    { title: options.title, disableTranslation: true },
  ],
  'request-research': () => [
    ...ORGANISATION_HOME,
    { title: 'phrase.request_research' },
  ],
  'request-research-builder': (options) => [
    ...ORGANISATION_HOME,
    { title: 'phrase.request_research', routeTo: { name: 'request-research' } },
    { title: options.title || '', disableTranslation: true },
  ],
  'organisation-research-proposal-intake-chat': () => [
    ...ORGANISATION_HOME,
    { title: 'phrase.request_research', routeTo: { name: 'request-research' } },
    { title: 'phrase.request_research_ai_intake' },
  ],
  'request-research-details': (options) => [
    ...ORGANISATION_HOME,
    { title: 'phrase.request_research', routeTo: { name: 'request-research' } },
    ...(options.researchTitle ? [{
      title: options.researchTitle,
      disableTranslation: true,
      routeTo: options.builderRoute,
    }] : []),
    { title: 'word.finish' },
  ],
  'organisation-document-list': () => ORGANISATION_DOCUMENTS_HOME,
  'organisation-detail': () => [
    ...ORGANISATION_HOME,
    { title: 'phrase.my_organisation', routeTo: { name: 'organisation-detail' } },
  ],
  'organisation-research-proposal-list': () => [
    ...ORGANISATION_HOME,
    { title: 'word.research_proposals', routeTo: { name: 'organisation-research-proposal-list' } },
  ],
  'organisation-research-proposal-detail': (options) => [
    ...ORGANISATION_HOME,
    { title: 'word.research_proposals', routeTo: { name: 'organisation-research-proposal-list' } },
    { title: options.title || 'word.research_proposal', disableTranslation: Boolean(options.title) },
  ],
  // The dashboard is the researches overview now, so ORGANISATION_HOME already
  // is the "back to the list" crumb; a separate one would point at the same page.
  'organisation-research-builder-v2': (options) => [
    ...ORGANISATION_HOME,
    { title: options.title || 'word.research_setup', disableTranslation: !options.title },
  ],
  'organisation-research-dashboard-v2': (options) => [
    ...ORGANISATION_HOME,
    { title: options.title || 'word.dashboard', disableTranslation: !options.title },
  ],
  'organisation-home': () => [],
};


// Shared breadcrumbs;
const SHARED_BREADCRUMBS = {
  'user-profile': () => [
    { title: 'phrase.my_account', routeTo: { name: 'user-profile' } },
  ],
}


export default {
  ...ADMIN_BREADCRUMBS,
  ...ORGANISATION_BREADCRUMBS,
  ...REVIEWER_BREADCRUMBS,
  ...SHARED_BREADCRUMBS,
}
